export default {
	name:'mainBox',
}